import { render, staticRenderFns } from "./authentication.vue?vue&type=template&id=0c9aabcd&"
import script from "./authentication.vue?vue&type=script&lang=js&"
export * from "./authentication.vue?vue&type=script&lang=js&"
import style0 from "./authentication.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports